module.exports = __webpack_public_path__ + "images/emails/bg-envelope-b-7dc2b7e4.gif";